"use client";
import "./index.es9.js";
import r, { useRef as u } from "react";
import "./index.es10.js";
import g from "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import c from "./index.es59.js";
const f = c.fieldset`
  display: flex;
  & > * {
    margin-right: 0.5rem;
    margin-top: 0.25rem;
    margin-bottom: 0.75rem;
  }

  legend {
    border: none;
  }
`, I = ({
  name: t,
  choices: m,
  value: n,
  id: l,
  label: o,
  onChange: i
}) => {
  const a = (e) => `radio-${t}-${e.value}`, p = u(null), d = (e) => () => {
    i(e.value);
  };
  return /* @__PURE__ */ r.createElement(f, { role: "radiogroup", id: l, ref: p }, !!o && /* @__PURE__ */ r.createElement("legend", null, o), m.map((e) => /* @__PURE__ */ r.createElement(
    g,
    {
      key: a(e),
      inputId: a(e),
      name: t,
      isChecked: n === e.value,
      onChange: d(e),
      label: e.display
    }
  )));
};
export {
  I as default
};
//# sourceMappingURL=index.es24.js.map
